import { graphqlClient } from "../../../client";
import mutationDocument from "./productsOnboarding.graphql";

export type productsOnboardingInput = {
  organizationId: string;
  companyName: string;
  vatNumber: string;
  description: string;
  populateProducts: boolean;
  hasSeenProductOnboarding?: boolean;
};

export type productsOnboardingResult = {
  organizationId: string;
  companyName: string;
  vatNumber: string;
  description: string;
  status: string;
  populateProducts: boolean;
  hasSeenProductOnboarding: boolean;
};

export async function productsOnboarding(command: productsOnboardingInput): Promise<productsOnboardingResult> {
  const { data } = await graphqlClient.mutate<{ productsOnboarding: productsOnboardingResult }>({
    mutation: mutationDocument,
    variables: { command },
  });

  return data!.productsOnboarding;
}
